module.exports = __webpack_public_path__ + "img/m1-screenshot-07.6ea2db66.png";